/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Flex, Button } from "@chakra-ui/react";
import { CustomerDetails } from "../../../components/customers/customer-details";

export default function Summary({
  customer,
  onCreateCustomer,
  editing,
  onPrevStep,
}) {
  const [customerDetails, setCustomerDetails] = useState({});
  useEffect(() => {
    setCustomerDetails(createCustomer());
  }, []);
  const createCustomer = () => {
    const _customerPayload = {
      clientId: customer.clientId,
      name: customer.name,
      shortName: customer.shortName,
      customerType: customer.customerType,
      customerCode: customer.customerCode,
      status: customer.status,
      hasSeparateDispenseCount: customer.hasSeparateDispenseCount,
      requiresEVhr: customer.requiresEVhr,
      requestedBy: customer.requestedBy,
      comments: customer.comments,
      offeredServices:
        customer.offeredServices?.map((service) => ({
          serviceName: service.serviceName,
          cassettes:
            service.cassettes?.map((cassette) => ({
              description: cassette.description || "",
              denomination: cassette.denomination,
              cassetteType: cassette.cassetteType,
              maker: cassette.maker,
              limit: cassette.limit,
              dualScanning: cassette.dualScanning,
            })) || [],
          denominations:
            service.denominations?.map((deno) => ({
              currency: deno.denominationCurrency || "",
              multiple: deno.denominationMultiple || "",
              shape: deno.shape,
              version: deno.version,
            })) || [],
        })) || [],
      accounts: (customer.accounts || []).map((acc) => ({
        title: acc.title,
        accountNo: acc.accountNo,
        branchCode: acc.branchCode,
      })),
      contactPersons: (customer.contactPersons || []).map((person) => ({
        firstName: person.firstName,
        lastName: person.lastName,
        mobileNo: person.mobileNo,
        email: person.email,
        personalMobileNo: person.personalMobileNo,
        officeNo: person.officeNo,
        designation: person.designation,
      })),
      insuranceLimits:
        customer.insuranceLimits?.map((limit) => ({
          type: limit.type,
          currency: limit.currency,
          pavement: limit.pavement,
          van: limit.van,
          bag: limit.bag,
        })) || [],
      replenishmentModels:
        customer.replenishmentModels?.map((model) => ({
          code: model.code,
          denominations:
            model.denominations?.map((deno) => ({
              denomination: `${deno.currency} ${deno.multiple}`,
              noOfCassettes: deno.noOfCassettes,
              noOfNotes: deno.noOfNotes,
            })) || [],
        })) || [],
      contracts: customer.contracts?.map((contract) => ({
        contractCode: contract.contractCode,
        autoRenew: contract.autoRenew,
        autoRenewFor: contract.autoRenewFor,
        startDate: contract.startDate,
        endDate: contract.endDate,
        status: contract.status,
        contractSLAs: contract.contractSLAs?.map((sla) => ({
          city: sla?.city?.id || "",
          serviceType: "",
          activityType: sla?.activityType || "",
          responseTime: Number(sla.responseTime),
          attendedTime: Number(sla.attendedTime),
          resolutionTime: Number(sla.resolutionTime),
        })),
        invoicingCatalogs:
          contract.invoicingCatalogs?.map((catalog) => ({
            invoicingCode: catalog.invoicingCode,
            currency: catalog?.currency || "",
            rate: catalog.rate,
            discount: catalog.discount,
          })) || [],
      })),
      escalationGroups: (customer.escalationGroups || []).map((group) => ({
        region: group.region,
        routeNo: group.routeNo,
        escalationLevel: `${group.escalationLevel}`,
        inAppRecipients: group.inAppRecipients?.map((rec) => rec.item) || [],
        emailRecipients: group.emailRecipients?.map((rec) => rec.item) || [],
        callRecipients: group.callRecipients?.map((rec) => rec.item) || [],
      })),
      serviceWindows:
        customer.serviceWindows?.map((window) => ({
          city: window.city,
          serviceType: window.serviceType,
          activityType: window.activityType,
          startTime: window.startTime,
          endTime: window.endTime,
        })) || [],
      lastCallTimings: (customer.lastCallTimings || []).map((timing) => ({
        city: timing.city,

        // BOOLEAN FLAGS
        isLastCallTime24HoursVaultAccess:
          timing.isLastCallTime24HoursVaultAccess || false,

        isLastCallTime24HoursNoVaultAccess:
          timing.isLastCallTime24HoursNoVaultAccess || false,
        // TIME VALUES (NULL when 24 hours)
        lastCallTimeVaultAccessRequired: timing.isLastCallTime24HoursVaultAccess
          ? null
          : timing.lastCallTimeVaultAccessRequired,

        lastCallTimeNoVaultAccessRequired:
          timing.isLastCallTime24HoursNoVaultAccess
            ? null
            : timing.lastCallTimeNoVaultAccessRequired,
      })),
      locationInitials: customer.locationInitials || [],
    };
    return _customerPayload;
  };

  return (
    <>
      <CustomerDetails customer={customerDetails} />
      <Flex
        style={{
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-end",
          gap: "16px",
          marginTop: "16px",
        }}
      >
        <Button onClick={onPrevStep}>Back</Button>
        <Button
          onClick={() => {
            onCreateCustomer(customerDetails);
          }}
        >
          {editing ? "Update Customer" : "Create Customer"}
        </Button>
      </Flex>
    </>
  );
}
